import { Injectable } from '@angular/core';
import { Wrapper } from '@skylab-angular-shared/core';
import { EventNotificationsServiceHandler } from '@skylab-shared/business';

@Injectable({providedIn: 'root'})
@Wrapper(EventNotificationsServiceHandler, {static: true})
export class EventNotificationsService {}
